import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Popup } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "./CustomPagination";

const AddUserDocPaginationTable = ({
  columns,
  data,
  setselectedUsersData,
  selectedUsers,
  onDataFromChild,
}) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(`${process.env.REACT_APP_ROWSPERPAGE}`)
  );
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    onDataFromChild(selectedCheckboxes);
  }, [selectedCheckboxes]);

  const ChangeUsersSelection = (row) => {
    const isUserSelected = selectedCheckboxes.some(
      (user) => user.id === row.id
    );
    if (isUserSelected) {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((user) => user.id !== row.id)
      );
    } else {
      setSelectedCheckboxes([
        ...selectedCheckboxes,
        { id: row.id, displayName: row.displayName, email: row.email },
      ]);
    }
  };

  const handleTableRowClick = (row) => {
    ChangeUsersSelection(row);
  };

  const totalItems = data.length;

  return (
    <Paper sx={{ overflowX: "auto" }} style={{ boxShadow: "none" }}>
      <TableContainer style={{ border: "none" }}>
        <Table style={{ borderCollapse: "collapse", border: "none" }}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  sx={{ minWidth: column.minWidth }}
                  style={{ minWidth: column.minWidth, borderBottom: "none" }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody data-cy="add-list-users-cy">
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.id} onClick={() => handleTableRowClick(row)}>
                  {columns.map((column) => (
                    <TableCell key={column.id}>
                      {column.id === "displayName" && (
                        <>
                          <div>
                            {row.displayName.length < 20 ? (
                              row.displayName
                            ) : (
                              <Popup
                                content={row.displayName}
                                inverted
                                position="right center"
                                style={{ borderRadius: "15px" }}
                                trigger={
                                  <span>{row.displayName.slice(0, 20)}..</span>
                                }
                              />
                            )}
                          </div>
                          <div className="usersPopupEmail">
                            {row.email.length < 30 ? (
                              row.email
                            ) : (
                              <Popup
                                content={row.email}
                                inverted
                                position="right center"
                                style={{ borderRadius: "15px" }}
                                trigger={
                                  <span>{row.email.slice(0, 30)}..</span>
                                }
                              />
                            )}
                          </div>
                        </>
                      )}
                    </TableCell>
                  ))}
                  <TableCell>
                    <input
                      value={row.id}
                      type="checkbox"
                      onChange={() => ChangeUsersSelection(row)}
                      className="user-list-checkbox"
                      checked={selectedCheckboxes.some(
                        (user) => user.id === row.id
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        totalItems={totalItems}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
      />
    </Paper>
  );
};

export default AddUserDocPaginationTable;
